export const clearLocalStorage = () => {
  localStorage.removeItem("xProfilePk");
  localStorage.removeItem("xAuthToken");
  localStorage.removeItem("xAuthRefreshToken");
  localStorage.removeItem("xProfile");
};
